var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mounting-portal',{attrs:{"mount-to":"#modal-wrapper","append":""}},[_c('div',{staticClass:"modal-wrapper position-fixed d-flex justify-content-center align-items-center",class:{'wrapper-transparent': _vm.isShowTransition},style:(_vm.wrapperBackground),on:{"click":_vm.closeWrapper}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }